import LABEL from '../../../business-const/Label/Label'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    formataValor,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    GridItem5,
    GridItem7,
    GridItem8,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    pesquisaList,
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import comparacaoCenariosGrupoList from '../../../business-rules/List/comparacaoCenariosEstudosGrupoList'

import comparacaoCenariosItemList from '../../../business-rules/List/comparacaoCenariosEstudosItemList'

import tipoPeriodicidadeList from '../../../business-rules/List/tipoPeriodicidadeList'

import {
    objetoCliente,
} from '../cliente-form/ClienteService'

import {
    obterCenario,
} from '../estudo-parametros/EstudoServiceCenarios'

import {
    ateMaisXAnos,
} from './EstudoService'

import {
    processaCalculoEstudo
} from './EstudoServiceCalculo'



export const calculaGridItemCenariosEstudos = (comparacaoCenariosEstudos, report) => {

    return comparacaoCenariosEstudos && comparacaoCenariosEstudos.length === 1
        ?
            (report ? GridItem7 : GridItem5)
        :
            comparacaoCenariosEstudos && comparacaoCenariosEstudos.length === 2
                    ?
                        (report ? GridItem8 : GridItem7)
                    :
                        comparacaoCenariosEstudos && comparacaoCenariosEstudos.length === 3
                            ?
                                (report ? GridItem10: GridItem8)
                            :
                                comparacaoCenariosEstudos && comparacaoCenariosEstudos.length === 4
                                    ?
                                        (report ? GridItem12 : GridItem10) 
                                    :
                                        GridItem12
}



export const calculaGridItemCenariosEstudosTabelaGrafico = (comparacaoCenariosEstudos) => {

    return comparacaoCenariosEstudos && comparacaoCenariosEstudos.length === 1
        ?
            GridItem5
        :
            comparacaoCenariosEstudos && comparacaoCenariosEstudos.length === 2
                    ?
                        GridItem7
                    :
                        comparacaoCenariosEstudos && comparacaoCenariosEstudos.length === 3
                            ?
                                GridItem8
                            :
                                comparacaoCenariosEstudos && comparacaoCenariosEstudos.length === 4
                                    ?
                                        GridItem10
                                    :
                                        GridItem12
}



const temCenarioComAplicarBalancoReceitaXDespesaPositivo = (values) => {

    let temCenario = false

    values.cenarios?.forEach( (linhaCenarios, indexCenarios) => {

        if (
                linhaCenarios.aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria &&
                !linhaCenarios.naoExibirComparacaoCenarios
        ) {

            temCenario = true
        }
    })

    return temCenario
}

const valorVazio = (valuesCenarioEstudo, comparacaoCenariosEstudos) => {

    const valorVazioAux = []

    if (comparacaoCenariosEstudos === HARDCODE.comparacaoCenariosEstudosTipoCenario) {

        valuesCenarioEstudo.cenarios?.forEach( (linhaCenarios, indexCenarios) => {

            if (!linhaCenarios.naoExibirComparacaoCenarios) {

                valorVazioAux.push(
                    null
                )
            }
        })

    } else {

        valuesCenarioEstudo.jsonComparacaoEstudos.estudos?.forEach( (linhaEstudos, indexEstudos) => {

            if (!linhaEstudos.naoExibirComparacaoEstudos) {

                valorVazioAux.push(
                    null
                )
            }
        })
    }

    return valorVazioAux
}

const incluiLinhaComparaCenario = (valuesCenarioEstudo, comparacaoCenariosGrupoAux, comparacaoCenariosItemAux, indexCenariosEstudos, idItem, valor,
    idNULL, descricaoNULL, comparacaoCenariosEstudos, somarNULL) => {

    let id

    if (idNULL) {

        id = idNULL

    } else {

        id = idItem
    }

    const linhaComparacaoCenariosItemList = pesquisaList(comparacaoCenariosItemList, idItem)

    const linhaComparacaoCenarios = pesquisaList(comparacaoCenariosItemAux, id)

    let index

    if (!linhaComparacaoCenarios.id) {

        index = comparacaoCenariosItemAux.length

        comparacaoCenariosItemAux.push(
            {
                id: id,
                idItem: idItem,
                descricao: descricaoNULL ? descricaoNULL : linhaComparacaoCenariosItemList.descricao,
                ordem: linhaComparacaoCenariosItemList.ordem,
                valor: valorVazio(valuesCenarioEstudo, comparacaoCenariosEstudos),
                index: index,
            }
        )

    } else {

        index = linhaComparacaoCenarios.index
    }

    if (somarNULL) {

        comparacaoCenariosItemAux[index].valor[indexCenariosEstudos] += valor

    } else {

        comparacaoCenariosItemAux[index].valor[indexCenariosEstudos] = valor
    }

    if (!pesquisaList(comparacaoCenariosGrupoAux, linhaComparacaoCenariosItemList.grupo).id) {

        comparacaoCenariosGrupoAux.push(
            pesquisaList(comparacaoCenariosGrupoList, linhaComparacaoCenariosItemList.grupo)
        )
    }
}

export const incluiSerieComparaCenario = (descricaoCenarioEstudo, comparacaoCenariosEstudosSeriesAux, comparacaoCenariosEstudosIdadesAux,
    comparacaoCenariosEstudosAnosAux, data, graficoIdades, graficoAnos) => {

    let dataAux = [...data]

    if (comparacaoCenariosEstudosSeriesAux.length === 0) {
    
        comparacaoCenariosEstudosIdadesAux.push(...graficoIdades)
        comparacaoCenariosEstudosAnosAux.push(...graficoAnos)

    } else {

        //let difIdades = graficoIdades[0] - comparacaoCenariosEstudosIdadesAux[0]

        //while (difIdades > 0) {

        //    dataAux = [null, ...dataAux]

        //    difIdades--
        //}

        //difIdades = graficoIdades[graficoIdades.length - 1] -
        //    comparacaoCenariosEstudosIdadesAux[comparacaoCenariosEstudosIdadesAux.length - 1]

        //while (difIdades > 0) {

        //    dataAux.splice(dataAux.length - 1, 1)

        //    difIdades--
        //}

        let difAnos = graficoAnos[0] - comparacaoCenariosEstudosAnosAux[0]

        while (difAnos > 0) {

            dataAux = [null, ...dataAux]

            difAnos--
        }

        difAnos = graficoAnos[graficoAnos.length - 1] -
            comparacaoCenariosEstudosAnosAux[comparacaoCenariosEstudosAnosAux.length - 1]

        while (difAnos > 0) {

            dataAux.splice(dataAux.length - 1, 1)

            difAnos--
        }
    }

    comparacaoCenariosEstudosSeriesAux.push(
        {
            name: descricaoCenarioEstudo,
            data: dataAux,
        },
    )

    //if (comparacaoCenariosEstudosIdadesAux.length < graficoIdades.length) {
        
    //    while (comparacaoCenariosEstudosIdadesAux.length > 0) {

    //        comparacaoCenariosEstudosIdadesAux.splice(0, 1)
    //    }

    //    comparacaoCenariosEstudosIdadesAux.push(...graficoIdades)
    //}
}

export const taxaJurosAnualZeroTraco = (valuesCenarioEstudo, valor) => {

    let valorTraco

    if (valuesCenarioEstudo.taxaRetornoAnualReal === 0 && valuesCenarioEstudo.taxaRetornoAnualRealAposAposentadoria === 0) {

        valorTraco = '-'

    } else {

        valorTraco = valor
    }

    return valorTraco
}

const processaCalculoEstudoComparacaoCenarios = (valuesCenarioEstudo, handleSubmitAutomatico, estudo, jsonConfiguracao, report,
    simulacaoFinanceira, calculaComparacaoFinanciamento) => {

    processaCalculoEstudo(valuesCenarioEstudo, handleSubmitAutomatico, estudo, report, true/*simulacaoFinanceira ? false : true*/,
        simulacaoFinanceira
            ?
                report
                    ?
                        HARDCODE.origemCalculoEstudoPrimeiraReuniaoReport
                    :
                        HARDCODE.origemCalculoEstudoPrimeiraReuniaoPlanilha
            :
                report
                    ?
                        HARDCODE.origemCalculoEstudoEstudoReport
                    :
                        HARDCODE.origemCalculoEstudoEstudo,
        false, jsonConfiguracao, calculaComparacaoFinanciamento)
}

export const calculaComparacaoCenariosEstudos = (valuesCenarioEstudo, handleSubmitAutomatico, estudo, jsonConfiguracao, report,
        comparacaoCenariosEstudosAuxLinha,  descricaoCenarioEstudo, comparacaoCenariosEstudosGrupoAux,
            comparacaoCenariosEstudosItemAux, comparacaoCenariosEstudosSeriesAux, comparacaoCenariosEstudosIdadesAux,
                comparacaoCenariosEstudosAnosAux, cenarioCalculo, indexCenariosEstudos, comparacaoCenariosEstudos,
                    simulacaoFinanceira) => {

    valuesCenarioEstudo.cenarioAtual = cenarioCalculo

    obterCenario(valuesCenarioEstudo, valuesCenarioEstudo.cenarioAtual)

    processaCalculoEstudoComparacaoCenarios(valuesCenarioEstudo, handleSubmitAutomatico, estudo, jsonConfiguracao, report,
        simulacaoFinanceira, false)

    incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
        HARDCODE.comparacaoCenariosEstudosIdadeDataSimulacaoCliente, valuesCenarioEstudo.idadeDataSimulacaoCliente, null, null,
            comparacaoCenariosEstudos)

    incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
        HARDCODE.comparacaoCenariosEstudosIdadeVaiAposentarCliente, valuesCenarioEstudo.idadeVaiAposentarCliente, null, null,
            comparacaoCenariosEstudos)

    incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
        HARDCODE.comparacaoCenariosEstudosIdadeFinalVitalicioClienteConjuge, valuesCenarioEstudo.idadeFinalVitalicioClienteConjuge,
            null, null, comparacaoCenariosEstudos)

    incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
        HARDCODE.comparacaoCenariosEstudosRetornoReal, valuesCenarioEstudo.taxaRetornoAnualRealPonderada, null, null, comparacaoCenariosEstudos)



    if (simulacaoFinanceira) {

        if (valuesCenarioEstudo.retiradaMensalAntesAposentarCliente) {

            incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
                HARDCODE.comparacaoCenariosEstudosNecessidadeAposentadoria,
                    round(valuesCenarioEstudo.retiradaMensalAntesAposentarCliente, 2),
                        HARDCODE.comparacaoCenariosEstudosNecessidadeAposentadoria + '-' + valuesCenarioEstudo.idadeDataSimulacaoCliente + '-' +
                            valuesCenarioEstudo.idadeVaiAposentarCliente,
                                valuesCenarioEstudo.idadeDataSimulacaoCliente + LABEL.ate +
                                    valuesCenarioEstudo.idadeVaiAposentarCliente + ' - ' +
                                        pesquisaDescricaoList(tipoPeriodicidadeList(false, false, false), HARDCODE.idTipoPeriodicidadeMensal),
                                            comparacaoCenariosEstudos)
        }

        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosNecessidadeAposentadoria,
                round(valuesCenarioEstudo.retiradaMensalDepoisAposentarCliente, 2),
                    HARDCODE.comparacaoCenariosEstudosNecessidadeAposentadoria + '-' + (valuesCenarioEstudo.idadeVaiAposentarCliente + 1) + '-' +
                        valuesCenarioEstudo.idadeFinalVitalicioClienteConjuge, (valuesCenarioEstudo.idadeVaiAposentarCliente + 1) + LABEL.ate +
                            valuesCenarioEstudo.idadeFinalVitalicioClienteConjuge + ' - ' +
                                    pesquisaDescricaoList(tipoPeriodicidadeList(false, false, false), HARDCODE.idTipoPeriodicidadeMensal),
                                        comparacaoCenariosEstudos)
        
        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosAportePlanejadoAposentadoria,
                round(valuesCenarioEstudo.aporteMensalAntesAposentarCliente, 2),
                    HARDCODE.comparacaoCenariosEstudosAportePlanejadoAposentadoria + '-' + valuesCenarioEstudo.idadeDataSimulacaoCliente + '-' +
                    valuesCenarioEstudo.idadeVaiAposentarCliente,
                        valuesCenarioEstudo.idadeDataSimulacaoCliente + LABEL.ate +
                            valuesCenarioEstudo.idadeVaiAposentarCliente + ' - ' +
                                pesquisaDescricaoList(tipoPeriodicidadeList(false, false, false), HARDCODE.idTipoPeriodicidadeMensal),
                                    comparacaoCenariosEstudos)

        if (valuesCenarioEstudo.aporteMensalDepoisAposentarCliente) {

            incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
                HARDCODE.comparacaoCenariosEstudosAportePlanejadoAposentadoria,
                    round(valuesCenarioEstudo.aporteMensalDepoisAposentarCliente, 2),
                        HARDCODE.comparacaoCenariosEstudosAportePlanejadoAposentadoria + '-' + (valuesCenarioEstudo.idadeVaiAposentarCliente + 1) + '-' +
                            valuesCenarioEstudo.idadeFinalVitalicioClienteConjuge, (valuesCenarioEstudo.idadeVaiAposentarCliente + 1) + LABEL.ate +
                                valuesCenarioEstudo.idadeFinalVitalicioClienteConjuge + ' - ' +
                                    pesquisaDescricaoList(tipoPeriodicidadeList(false, false, false), HARDCODE.idTipoPeriodicidadeMensal),
                                        comparacaoCenariosEstudos)
        }

        valuesCenarioEstudo.aporteRetiradaMensal?.forEach( (linhaAporteRetiradaMensal, indAporteRetiradaMensal) => {

            if (linhaAporteRetiradaMensal.retiradaMensal) {

                incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,
                    indexCenariosEstudos, HARDCODE.comparacaoCenariosEstudosNecessidadeAposentadoria,
                        round(linhaAporteRetiradaMensal.retiradaMensal, 2),
                            HARDCODE.comparacaoCenariosEstudosNecessidadeAposentadoria + '-' + LABEL.retiradaMensal + '-' +
                                linhaAporteRetiradaMensal.idadeInicial + '-' + linhaAporteRetiradaMensal.idadeFinal + '-' + linhaAporteRetiradaMensal.retiradaMensal,
                                    linhaAporteRetiradaMensal.idadeInicial + LABEL.ate + linhaAporteRetiradaMensal.idadeFinal + ' - ' +
                                        pesquisaDescricaoList(tipoPeriodicidadeList(false, false, false), HARDCODE.idTipoPeriodicidadeMensal),
                                            comparacaoCenariosEstudos, true)
            }

            if (linhaAporteRetiradaMensal.aporteMensal) {

                incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,
                    indexCenariosEstudos, HARDCODE.comparacaoCenariosEstudosAportePlanejadoAposentadoria,
                        round(linhaAporteRetiradaMensal.aporteMensal, 2),
                            HARDCODE.comparacaoCenariosEstudosAportePlanejadoAposentadoria + '-' + LABEL.aporteMensal + '-' +
                                linhaAporteRetiradaMensal.idadeInicial + '-' + linhaAporteRetiradaMensal.idadeFinal+ '-' + linhaAporteRetiradaMensal.aporteMensal,
                                    linhaAporteRetiradaMensal.idadeInicial + LABEL.ate + linhaAporteRetiradaMensal.idadeFinal + ' - ' +
                                        pesquisaDescricaoList(tipoPeriodicidadeList(false, false, false), HARDCODE.idTipoPeriodicidadeMensal),
                                            comparacaoCenariosEstudos, true)
            }
        })    

        valuesCenarioEstudo.aporteRetiradaAnual?.forEach( (linhaAporteRetiradaAnual, indAporteRetiradaAnual) => {

            if (linhaAporteRetiradaAnual.retiradaAnual) {

                incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,
                    indexCenariosEstudos, HARDCODE.comparacaoCenariosEstudosNecessidadeAposentadoria,
                        round(linhaAporteRetiradaAnual.retiradaAnual, 2),
                            HARDCODE.comparacaoCenariosEstudosNecessidadeAposentadoria + '-' + LABEL.retiradaAnual + '-' +
                                linhaAporteRetiradaAnual.idade + '-' + linhaAporteRetiradaAnual.idadeFinal + '-' + linhaAporteRetiradaAnual.retiradaAnual,
                                    linhaAporteRetiradaAnual.idade +
                                        (linhaAporteRetiradaAnual.idadeFinal ? LABEL.ate + linhaAporteRetiradaAnual.idadeFinal : '') + ' - ' +
                                            pesquisaDescricaoList(tipoPeriodicidadeList(false, false, false), HARDCODE.idTipoPeriodicidadeAnual),
                                                comparacaoCenariosEstudos, true)
            }

            if (linhaAporteRetiradaAnual.aporteAnual) {

                incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,
                    indexCenariosEstudos, HARDCODE.comparacaoCenariosEstudosAportePlanejadoAposentadoria,
                        round(linhaAporteRetiradaAnual.aporteAnual, 2),
                            HARDCODE.comparacaoCenariosEstudosAportePlanejadoAposentadoria + '-' + LABEL.aporteAnual + '-' +
                                linhaAporteRetiradaAnual.idade + '-' + linhaAporteRetiradaAnual.idadeFinal + '-' + linhaAporteRetiradaAnual.aporteAnual,
                                    linhaAporteRetiradaAnual.idade +
                                        (linhaAporteRetiradaAnual.idadeFinal ? LABEL.ate + linhaAporteRetiradaAnual.idadeFinal : '') + ' - ' +
                                            pesquisaDescricaoList(tipoPeriodicidadeList(false, false, false), HARDCODE.idTipoPeriodicidadeAnual),
                                                comparacaoCenariosEstudos, true)
            }
        })    

        

        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosValorPresenteReservaInicioAposentadoria,
                valuesCenarioEstudo.valorRecursosFinanceirosInicioAposentadoria, null, null, comparacaoCenariosEstudos)

                
        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosRecursosFinanceirosAcumuladosAposentadoriaIdadeAte,
                ateMaisXAnos(valuesCenarioEstudo.idadeLimiteReservaAposentadoria, valuesCenarioEstudo.idadeExpectativaVidaCliente),
                    null, null, comparacaoCenariosEstudos)

        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosRecursosFinanceirosIdadeFinalVitalicioClienteConjuge,
                valuesCenarioEstudo.valorRecursosFinanceirosFinalAposentadoria, null, null, comparacaoCenariosEstudos)

        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,  indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosRetiradaMensalMaximaConsumirReservaAposentadoria,
                valuesCenarioEstudo.retiradaMensalMaximaConsumirReservaAposentadoria, null, null, comparacaoCenariosEstudos)

        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,  indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosRetiradaMensalMaximaPreservarReservaAposentadoria, taxaJurosAnualZeroTraco(valuesCenarioEstudo,
                valuesCenarioEstudo.retiradaMensalMaximaPreservarReservaAposentadoria), null, null, comparacaoCenariosEstudos)

        comparacaoCenariosEstudosAuxLinha.retiradaMensalMaximaPreservarReservaAposentadoria =
            valuesCenarioEstudo.retiradaMensalMaximaPreservarReservaAposentadoria

        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,  indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosAporteMensalConsumirReservaAposentadoria, valuesCenarioEstudo.aporteMensalAdicionalConsumirReservaAposentadoria, null, null,
                comparacaoCenariosEstudos)
            
        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,  indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosAporteMensalPreservarReservaAposentadoria,
                taxaJurosAnualZeroTraco(valuesCenarioEstudo, valuesCenarioEstudo.aporteMensalAdicionalPreservarReservaAposentadoria), null, null,
                    comparacaoCenariosEstudos)
                    
        comparacaoCenariosEstudosAuxLinha.aporteMensalAdicionalPreservarReservaAposentadoria =
            valuesCenarioEstudo.aporteMensalAdicionalPreservarReservaAposentadoria
            
        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,  indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosAporteUnicoConsumirReservaAposentadoria, valuesCenarioEstudo.aporteUnicoAdicionalConsumirReservaAposentadoria,
                null, null, comparacaoCenariosEstudos)
            
        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,  indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosAporteUnicoPreservarReservaAposentadoria, taxaJurosAnualZeroTraco(valuesCenarioEstudo,
                valuesCenarioEstudo.aporteUnicoAdicionalPreservarReservaAposentadoria), null, null, comparacaoCenariosEstudos)

        incluiSerieComparaCenario(descricaoCenarioEstudo, comparacaoCenariosEstudosSeriesAux, comparacaoCenariosEstudosIdadesAux,
            comparacaoCenariosEstudosAnosAux, estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoSituacaoReal,
                estudo.current.graficoIdades, estudo.current.graficoAnos)

    } else {

        estudo.current.projetoVidaSonhoTracarMeta?.forEach( (linhaProjetoVidaSonhoTracarMeta, indProjetoVidaSonhoTracarMeta) => {

            if (linhaProjetoVidaSonhoTracarMeta.exibirComparacaoCenarios) {

                incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
                    HARDCODE.comparacaoCenariosEstudosProjetosVidaSonho,
                        linhaProjetoVidaSonhoTracarMeta.valorAporteProjetoVidaSonho,
                            HARDCODE.comparacaoCenariosEstudosProjetosVidaSonho + '-' + linhaProjetoVidaSonhoTracarMeta.id,
                                linhaProjetoVidaSonhoTracarMeta.descricao + ": " + linhaProjetoVidaSonhoTracarMeta.nomeCurtoFamiliar +
                                    ' (' + formataValor(linhaProjetoVidaSonhoTracarMeta.valorSemFormatacao, 2) + ')',
                                    comparacaoCenariosEstudos)
            }
        })



        estudo.current.necessidadeAposentadoria?.forEach( (linhaNecessidadeAposentadoria, indAporteNecessidadeAposentadoria) => {

            incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
                HARDCODE.comparacaoCenariosEstudosNecessidadeAposentadoria,
                    linhaNecessidadeAposentadoria.despesasExcedentesMensal,
                        HARDCODE.comparacaoCenariosEstudosNecessidadeAposentadoria + '-' + linhaNecessidadeAposentadoria.idadeDe + '-' +
                            linhaNecessidadeAposentadoria.idadeAte,
                                linhaNecessidadeAposentadoria.idadeDe + LABEL.ate +
                                    linhaNecessidadeAposentadoria.idadeAte + ' - ' +
                                        pesquisaDescricaoList(tipoPeriodicidadeList(false, false, false), HARDCODE.idTipoPeriodicidadeMensal),
                                            comparacaoCenariosEstudos)
        })    




        if (temCenarioComAplicarBalancoReceitaXDespesaPositivo(valuesCenarioEstudo)) {
        
            incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
                HARDCODE.comparacaoCenariosEstudosAporteEconomiaReceitaMensal,
                    valuesCenarioEstudo.percAplicarBalancoReceitaXDespesaPositivoAteAposentadoriaRecursosFinanceirosUtilizado, null, null,
                        comparacaoCenariosEstudos)
        }

        estudo.current.aportePlanejadoAposentadoria?.forEach( (linhaAportePlanejadoAposentadoria, indAportePlanejadoAposentadoria) => {

            if (linhaAportePlanejadoAposentadoria.id !== LABEL.economiaReceitaMensal) {

                incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
                    HARDCODE.comparacaoCenariosEstudosAportePlanejadoAposentadoria,
                        linhaAportePlanejadoAposentadoria.valorPercAporteDividendosContribuicao,
                            HARDCODE.comparacaoCenariosEstudosAportePlanejadoAposentadoria + '-' +
                                linhaAportePlanejadoAposentadoria.mesAnoInicialAporteDividendos + '-' +
                                    linhaAportePlanejadoAposentadoria.mesAnoFinalAporteDividendos + '-' + linhaAportePlanejadoAposentadoria.id,
                                        linhaAportePlanejadoAposentadoria.mesAnoInicialAporteDividendos + LABEL.ate +
                                            linhaAportePlanejadoAposentadoria.mesAnoFinalAporteDividendos + ' - ' +
                                                linhaAportePlanejadoAposentadoria.descricaoTipoPeriodicidadeAporteDividendos, comparacaoCenariosEstudos)
            }
        })



        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosValorPresenteReservaInicioAposentadoria,
                valuesCenarioEstudo.valorPresenteReservaInicioAposentadoria, null, null, comparacaoCenariosEstudos)

        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosValorPresenteNecessidadesInicioAposentadoria,
                valuesCenarioEstudo.valorPresenteNecessidadesInicioAposentadoria, null, null, comparacaoCenariosEstudos)

        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux, indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosSuperavitDeficitAposentadoria,
                valuesCenarioEstudo.valorPresenteDeficitReservaInicioAposentadoria > 0 ?
                    valuesCenarioEstudo.valorPresenteDeficitReservaInicioAposentadoria * -1 :
                        valuesCenarioEstudo.valorPresenteSuperavitReservaInicioAposentadoria,
                            null, null, comparacaoCenariosEstudos)
                
        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,
            indexCenariosEstudos, HARDCODE.comparacaoCenariosEstudosRecursosFinanceirosAcumuladosAposentadoriaIdadeAte,
                ateMaisXAnos(valuesCenarioEstudo.recursosFinanceirosAcumuladosAposentadoriaIdadeAte,
                    valuesCenarioEstudo.idadeExpectativaVidaCliente), null, null, comparacaoCenariosEstudos)

        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,  indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosRetiradaMensalMaximaConsumirReservaAposentadoria,
                valuesCenarioEstudo.valorRetiradaMensalMaximaConsumirReservaAposentadoria, null, null, comparacaoCenariosEstudos)
            
        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,  indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosRetiradaMensalMaximaPreservarReservaAposentadoria, taxaJurosAnualZeroTraco(valuesCenarioEstudo,
                valuesCenarioEstudo.valorRetiradaMensalMaximaPreservarReservaAposentadoria), null, null, comparacaoCenariosEstudos)

        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,  indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosAporteMensalConsumirReservaAposentadoria, valuesCenarioEstudo.valorPresenteDeficitSimulacaoMensal, null, null,
                comparacaoCenariosEstudos)
            
        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,  indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosAporteMensalPreservarReservaAposentadoria,
                taxaJurosAnualZeroTraco(valuesCenarioEstudo, valuesCenarioEstudo.valorAporteMensalPreservarReservaAposentadoria), null, null,
                    comparacaoCenariosEstudos)
            
        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,  indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosAporteUnicoConsumirReservaAposentadoria, valuesCenarioEstudo.valorDepositoUnicoManterPadraoVida, null, null,
                comparacaoCenariosEstudos)
            
        incluiLinhaComparaCenario(valuesCenarioEstudo, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,  indexCenariosEstudos,
            HARDCODE.comparacaoCenariosEstudosAporteUnicoPreservarReservaAposentadoria, taxaJurosAnualZeroTraco(valuesCenarioEstudo,
                valuesCenarioEstudo.valorDepositoUnicoViverRentabilidade), null, null, comparacaoCenariosEstudos)

        incluiSerieComparaCenario(descricaoCenarioEstudo, comparacaoCenariosEstudosSeriesAux, comparacaoCenariosEstudosIdadesAux,
            comparacaoCenariosEstudosAnosAux, estudo.current.graficoIndependenciaFinanceiraSituacaoAtual,
                estudo.current.graficoIdades, estudo.current.graficoAnos)
    }
}

export const complementaValuesAposObjetoCliente = (valuesNovo, values, versao) => {

    valuesNovo.id = values.id
    valuesNovo.ultimaVersao = values.ultimaVersao
    valuesNovo.jsonComparacaoEstudos = JSON.parse(JSON.stringify(values.jsonComparacaoEstudos))//{...values.jsonComparacaoEstudos}
    valuesNovo.versao = versao
    valuesNovo.tabIndexEstudo = 8
}

export const processaComparacaoCenariosEstudos = (variaveisGlobais, values, handleSubmitAutomatico, estudo,
    report, jsonConfiguracao, comparacaoCenariosEstudos, simulacaoFinanceira) => {

    const cenarioAnt = values.cenarioAtual

    const comparacaoCenariosEstudosAux = []
    const comparacaoCenariosEstudosGrupoAux = []
    const comparacaoCenariosEstudosItemAux = []
    const comparacaoCenariosEstudosSeriesAux = []
    const comparacaoCenariosEstudosIdadesAux = []
    const comparacaoCenariosEstudosAnosAux = []

    if (comparacaoCenariosEstudos === HARDCODE.comparacaoCenariosEstudosTipoCenario) {

        values.cenarios?.forEach( (linhaCenarios, indexCenarios) => {

            if (!linhaCenarios.naoExibirComparacaoCenarios) {

                comparacaoCenariosEstudosAux.push(linhaCenarios)

                const indexCenariosAux = comparacaoCenariosEstudosAux.length - 1

                calculaComparacaoCenariosEstudos(values, handleSubmitAutomatico, estudo, jsonConfiguracao, report,
                    comparacaoCenariosEstudosAux[indexCenariosAux], comparacaoCenariosEstudosAux[indexCenariosAux].descricao,
                        comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,
                            comparacaoCenariosEstudosSeriesAux, comparacaoCenariosEstudosIdadesAux, comparacaoCenariosEstudosAnosAux,
                                linhaCenarios.id, indexCenariosAux, comparacaoCenariosEstudos, simulacaoFinanceira)
            }
        })

    } else {

        values.jsonComparacaoEstudos.estudos?.forEach( (linhaEstudos, indexEstudos) => {

            if (!linhaEstudos.naoExibirComparacaoEstudos) {

                comparacaoCenariosEstudosAux.push({...pesquisaList(linhaEstudos.cenarios, linhaEstudos.cenarioPrincipal)})
                
                const indexCenariosAux = comparacaoCenariosEstudosAux.length - 1

                const descricaoCenarioEstudo = linhaEstudos.descricao + ' - ' + comparacaoCenariosEstudosAux[indexCenariosAux].descricao
                
                comparacaoCenariosEstudosAux[indexCenariosAux].descricao =
                    linhaEstudos.descricao + '<br/> ' + comparacaoCenariosEstudosAux[indexCenariosAux].descricao

                let valuesEstudo

                if (linhaEstudos.id === values.versao) {

                    valuesEstudo = JSON.parse(JSON.stringify(objetoCliente(variaveisGlobais, values, null, null)))//{...values}
                    complementaValuesAposObjetoCliente(valuesEstudo, values, linhaEstudos.id)

                } else {

                    values.versoesInfoclient?.forEach( (linhaVersoesInfoclient, indexVersoesInfoclient) => {

                        if (linhaVersoesInfoclient.versao === linhaEstudos.id) {

                            valuesEstudo = JSON.parse(JSON.stringify(objetoCliente(variaveisGlobais, linhaVersoesInfoclient.jsonInfoclient, null, null)))//{...linhaVersoesInfoclient.jsonInfoclient}
                            complementaValuesAposObjetoCliente(valuesEstudo, values, linhaEstudos.id)
                        }
                    })
                }

                calculaComparacaoCenariosEstudos(valuesEstudo, handleSubmitAutomatico, estudo, jsonConfiguracao, report,
                    comparacaoCenariosEstudosAux[indexCenariosAux], descricaoCenarioEstudo, comparacaoCenariosEstudosGrupoAux,
                        comparacaoCenariosEstudosItemAux, comparacaoCenariosEstudosSeriesAux, comparacaoCenariosEstudosIdadesAux,
                            comparacaoCenariosEstudosAnosAux, linhaEstudos.cenarioPrincipal, indexCenariosAux, comparacaoCenariosEstudos,
                                simulacaoFinanceira)
            }
        })
    }

    values.cenarioAtual = cenarioAnt

    obterCenario(values, values.cenarioAtual)

    processaCalculoEstudoComparacaoCenarios(values, handleSubmitAutomatico, estudo, jsonConfiguracao, report,
        simulacaoFinanceira, true)

    return { comparacaoCenariosEstudosAux, comparacaoCenariosEstudosGrupoAux, comparacaoCenariosEstudosItemAux,
        comparacaoCenariosEstudosSeriesAux, comparacaoCenariosEstudosIdadesAux, comparacaoCenariosEstudosAnosAux }
}